import { fetchVoucherData } from 'app/pages/TicketSalePage/slice';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  API_REQUEST_STATUS_FAIL,
  API_REQUEST_STATUS_NOT_SENT,
  API_REQUEST_STATUS_PENDING,
  API_REQUEST_STATUS_SUCCESS,
} from 'utils/static/constants';

const useVoucherData = (eventId, voucherCode, showErrorToast) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [voucherRequestStatus, setVoucherRequestStatus] = useState(
    API_REQUEST_STATUS_PENDING,
  );

  const getVoucherData = async () => {
    try {
      if (voucherCode) {
        const result = await dispatch(
          fetchVoucherData({
            eventId,
            voucherCode,
            uuid: '',
          }),
        );

        if (result.payload.voucher_error) {
          showErrorToast(result.payload.voucher_error);
          setVoucherRequestStatus(API_REQUEST_STATUS_FAIL);

          return;
        }

        // if the code doesn't exist the server doesn't retrieve an error, so we set it from here
        if (!result.payload.voucher.data.id) {
          showErrorToast(t('ticketSale.invalidCouponCode'));
          setVoucherRequestStatus(API_REQUEST_STATUS_FAIL);

          return;
        }

        setVoucherRequestStatus(API_REQUEST_STATUS_SUCCESS);
      } else {
        setVoucherRequestStatus(API_REQUEST_STATUS_NOT_SENT);
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        showErrorToast(error.response?.data.error.message);
        setVoucherRequestStatus(API_REQUEST_STATUS_FAIL);
        return;
      }

      navigate('/404');
    }
  };

  useEffect(() => {
    getVoucherData();
  }, []);

  return voucherRequestStatus;
};

export default useVoucherData;
